"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconBilling = function IconBilling(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconBilling', className),
    style: style,
    viewBox: "0 0 21 21"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, _react.default.createElement("path", {
    strokeWidth: "1.3",
    d: "M20.048 8.619v6.429a5 5 0 0 1-4.783 4.995l-.217.005v-.171a2 2 0 0 0 1.19-1.83V8.62h3.81z"
  }), _react.default.createElement("path", {
    strokeWidth: "1.3",
    d: "M1 1l3.81 2.857L8.619 1l3.81 2.857L16.239 1v17.048a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V1z"
  }), _react.default.createElement("path", {
    fill: "currentColor",
    strokeWidth: ".25",
    d: "M8.346 16.032v-1.004c-1.151-.068-2.02-.541-2.584-1.185l.553-.71c.44.496 1.128.959 2.03 1.06V11.44C7.196 11.124 6 10.74 6 9.352c0-1.173.982-1.997 2.347-2.076V6.238h.688v1.05c.937.09 1.67.45 2.223 1.026l-.564.689a2.76 2.76 0 0 0-1.659-.858v2.449c1.162.327 2.392.767 2.392 2.234 0 1.027-.654 2.065-2.392 2.2v1.004h-.688zm2.11-3.125c0-.734-.632-1.038-1.422-1.275v2.561c1.072-.113 1.422-.756 1.422-1.286zM6.969 9.296c0 .632.61.891 1.377 1.117V8.111c-.813.057-1.377.52-1.377 1.185z"
  })));
};

var _default = IconBilling;
exports.default = _default;